// Manejo del token JWT del módulo administrativo (localStorage del navegador).

const KEY = "loremig_admin_token";

export function getToken() {
  return localStorage.getItem(KEY);
}

export function setToken(token) {
  localStorage.setItem(KEY, token);
}

export function clearToken() {
  localStorage.removeItem(KEY);
}

// fetch con el token ya puesto en un header propio; si el token expiró (401),
// lo borra para que la app regrese a la pantalla de login.
// Nota: no se usa el header "Authorization" porque Azure Static Web Apps lo
// sobrescribe siempre en las Functions administradas (Easy Auth del host,
// que no se puede desactivar), así que el JWT propio nunca llegaría intacto.
export async function authFetch(url, options = {}) {
  const token = getToken();
  const res = await fetch(url, {
    ...options,
    headers: {
      ...(options.headers || {}),
      "X-Admin-Token": token || "",
    },
  });
  if (res.status === 401) clearToken();
  return res;
}
